import { observable, action, runInAction, makeAutoObservable, makeObservable } from 'mobx';

export class BaseStore {
  isLoading = true;

  constructor() {
    makeObservable(this, {
      isLoading: observable,
    });
  }

  private _fetchData = async <T>(fetchFn: (...args) => Promise<T>, onSuccess?: (res: T) => void) => {
    try {
      this.isLoading = true;
      let data = await fetchFn();
      if (onSuccess) {
        runInAction(() => onSuccess(data));
      }
      return data;
    } catch (ex) {
      throw ex;
    } finally {
      runInAction(() => (this.isLoading = false));
    }
  };
  protected get fetchData() {
    return this._fetchData;
  }
  protected set fetchData(value) {
    this._fetchData = value;
  }
}
